/**
 * Session Expired Message Component
 *
 * Displays a login modal when session expires.
 * Allows users to log in without leaving their current page.
 */
import React from 'react';
import LoginModal from './LoginModal';
import { useSessionExpired } from '../../contexts/SessionExpiredContext';
import { getAuthUrl } from '../../utils/subdomainUtils';
import { logger } from "../../utils/logger";
// import { logger } from "../../utils/logger";
const SessionExpiredMessage: React.FC = () => {
    // Use context - if not available, component will fail gracefully
    // This component should always be inside SessionExpiredProvider
    const { isExpired, handleModalLoginSuccess } = useSessionExpired();
    // Don't render if session is not expired
    if (!isExpired) {
        return null;
    }
    const handleSuccess = (user: any) => {
        logger.auth('✅ Login successful in SessionExpiredMessage', { "arg0": user });
        // LoginModal already updates auth context internally via its own useAuth
        // Just reset session expired state
        handleModalLoginSuccess();
    };
    const handleClose = () => {
        logger.auth('🚪 User closed session expired modal, redirecting to home');
        window.location.href = getAuthUrl('/');
    };
    return (<LoginModal open={isExpired} onClose={handleClose} onSuccess={handleSuccess} title="Session Expired" description="Your session has expired. Please log in again to continue."/>);
};
export default SessionExpiredMessage;
